import { useState } from "react"
import PropTypes from "prop-types"
import { Combobox } from "@reach/combobox"
import ComboBoxDropdown from "./ComboBoxDropdown"
import { isBlank, get } from "utils/helpers"

const ComboBox = ({
  ariaLabel = "select an item",
  placeholder = "",
  onSelect = () => null,
  defaultItem = null,
  itemKey = "value",
  disabled = false,
  items = []
}) => {
  const [value, setValue] = useState(get(defaultItem, itemKey, ""))
  const [selectedItem, setSelectedItem] = useState(defaultItem)
  const [filteredItems, setFilteredItems] = useState(items)

  const handleClear = () => {
    setValue("")
    setSelectedItem(null)
    onSelect(null)
  }

  const handleChange = e => {
    const newValue = e.target.value
    setValue(newValue)

    let filtered = items

    if (!isBlank(newValue)) {
      filtered = items.filter(item => item[itemKey].toLowerCase().includes(newValue.toLowerCase()))
    }

    setFilteredItems(filtered)
  }

  const handleSelect = itemValue => {
    const item = items.find(item => !item.isDisabled && item[itemKey] === itemValue)

    if (isBlank(item)) {
      return
    }

    setValue(itemValue)
    setSelectedItem(item)
    onSelect(item, handleClear)
  }

  return (
    <Combobox openOnFocus disabled={disabled} onSelect={handleSelect} aria-label={ariaLabel}>
      <ComboBoxDropdown
        disabled={disabled}
        placeholder={placeholder}
        selectedItem={selectedItem}
        items={filteredItems}
        value={value}
        onChange={handleChange}
        onClear={handleClear}
        itemKey={itemKey}
      />
    </Combobox>
  )
}

ComboBox.propTypes = {
  ariaLabel: PropTypes.string,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  defaultItem: PropTypes.shape({}),
  itemKey: PropTypes.string,
  items: PropTypes.array,
  disabled: PropTypes.bool
}

export default ComboBox
